import { render, staticRenderFns } from "./admin-setting.vue?vue&type=template&id=ce3805f4"
import script from "./admin-setting.vue?vue&type=script&lang=js"
export * from "./admin-setting.vue?vue&type=script&lang=js"
import style0 from "./admin-setting.vue?vue&type=style&index=0&id=ce3805f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports